import { Button, Flex, Input, Table, Tbody, Td, Text, Th, Thead, Tr, useColorModeValue } from '@chakra-ui/react';
import Card from 'components/Card/Card';
import LogsController from 'controllers/Logs/LogsController';
import { useEffect, useState } from 'react';

function LogsView() {
  const textColor = useColorModeValue("gray.700", "white");
  const [logs, setLogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const { logs: logsData, total_pages: totalPagesData } = await LogsController.ListLogs(currentPage, searchTerm);
        setLogs(logsData);
        setTotalPages(totalPagesData);
      } catch (error) {
        console.error("Error fetching logs:", error);
      }
    };

    fetchLogs();
  }, [currentPage, searchTerm]);

  const goToPreviousPage = async () => {
    try {
      const updatedPage = Math.max(1, currentPage - 1);
      setCurrentPage(updatedPage);
    } catch (error) {
      console.error('Erro ao buscar a página anterior:', error);
    }
  };

  const goToNextPage = async () => {
    try {
      const updatedPage = Math.min(totalPages, currentPage + 1);
      setCurrentPage(updatedPage);
    } catch (error) {
      console.error('Erro ao buscar a próxima página:', error);
    }
  };

  const handleSearchTermChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  return (
    <Flex direction='column' height="full" width="100%">
      <Card overflowX={{ sm: "scroll", xl: "hidden" }}>
        <Input
          type="text"
          value={searchTerm}
          onChange={handleSearchTermChange}
          placeholder="Filtrar registros..."
          _placeholder={{ color: 'gray.400' }}
          borderRadius="md"
        />
        <Flex justifyContent="space-between" alignItems="center">
          <Button size="sm" onClick={goToPreviousPage} mr={2} disabled={currentPage === 1}>
            Página anterior
          </Button>
          <Text>
            Página: {currentPage} de {totalPages}
          </Text>
          <Button size="sm" onClick={goToNextPage} ml={2} disabled={currentPage === totalPages}>
            Próxima página
          </Button>
        </Flex>
        <Table variant='simple' color={textColor}>
          <Thead>
            <Tr color='gray.400'>
              <Th color={textColor}>ID</Th>
              <Th color={textColor}>USUÁRIO</Th>
              <Th color={textColor}>MÓDULO</Th>
              <Th color={textColor}>AÇÃO</Th>
              <Th color={textColor}>RESUMO</Th>
              <Th color={textColor}>OCORRÊNCIA</Th>
            </Tr>
          </Thead>
          <Tbody>
            {logs.map((log, index) => (
              <Tr key={index}>
                <Td>{log.id}</Td>
                <Td>{log.usuario}</Td>
                <Td>{log.modulo}</Td>
                <Td>{log.ação}</Td>
                <Td>{log.resumo}</Td>
                <Td>{log.ocorrencia}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Card>
    </Flex>
  );
}

export default LogsView;